import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import NativeSelectInput from '../../../../components/shared/components/NativeSelectInput';
import BootstrapInput from '../../../shared/components/OutlinedInputBox';
import IconButton from '@material-ui/core/IconButton';
import Person from '@material-ui/icons/Person';
import Group from '@material-ui/icons/Group';
import Public from '@material-ui/icons/Public';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { countries } from '../../../../constants';
import Slider from '@material-ui/lab/Slider';
import Button from '@material-ui/core/Button';
import HpTooltip from '../../../../components/shared/components/hpTooltip';

const styles = theme => ({
  root: {
    paddingLeft: '5%',
    paddingRight: '5%'
  },
  gridColumn: {
    paddingRight: '40px',
    paddingLeft: '40px'
  },
  dropdown: {
    width: '85%'
  },
  socialSelection: {
    cursor: 'pointer'
  },
  urlButton: {
    color: 'black'
  },
  urlButtonSelected: {
    color: 'white'
  },
  buttonMargin: {
    marginLeft: '20px'
  },
  rowSection: {
    marginBottom: '30px'
  },
  scaleText: {
    display: 'inline'
  },
  scaleCaption: {
    marginLeft: '5px',
    justifyContent: 'center',
    display: 'inline'
  },
  icon: {
    backgroundColor: 'white',
    color: 'black',
    cursor: 'pointer'
  },
  iconSelected: {
    backgroundColor: '#5DBE76',
    color: 'white'
  },
  item: {
    color: 'black'
  },
  itemSelected: {
    color: '#5DBE76'
  },
  LevelDiv: {
    marginLeft: '10px',
    paddingTop: '5px',
    maxWidth: '100px'
  },
  select: {
    width: '100%',
    marginTop: '0px',
    marginBottom: '0px',
    '& > *': {
      maxWidth: 500,
      width: '100%',
      margin: '0 auto'
    }
  },
  selectMenu: {
    '& .MuiPopover-paper': {
      maxHeight: 250
    }
  },
  backButton: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    color: '#000000',
    paddingLeft: 50,
    paddingRight: 50
  },
  nextButton: {
    marginTop: theme.spacing.unit * 3,
    color: '#ffffff',
    paddingLeft: 50,
    paddingRight: 50
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center'
  },
  minAgeSlider: {
    marginTop: '30px'
  },
  levelContainer: {
    marginBottom: '15px'
  }
});

const StyledButton = withStyles({
  root: {
    borderRadius: '5px',
    height: '100px',
    width: '100px'
  }
})(IconButton);

class CampaignAudience extends React.Component {
  render() {
    const {
      classes,
      campaignInfo,
      changeHandler,
      influenceLevelClick,
      genderClick,
      ageSelectionHandler,
      country,
      backButtonClick,
      nextButtonClick
    } = this.props;
    return (
      <React.Fragment>
        <div className={classes.root}>
          <Grid
            container
            direction="row"
            align="left"
            justify="center"
            spacing={4}
          >
            <Grid item xs={12} sm={6}>
              <div className={classes.rowSection}>
                <div>
                  <Typography gutterBottom align="left" display="inline">
                    Gender
                  </Typography>
                  <HpTooltip
                    styling={{
                      marginLeft: '5px',
                      marginBottom: '2px'
                    }}
                    message={
                      'Select which gender you want to market your product/service to.'
                    }
                  />
                </div>
                <Button
                  id="isShippableProduct"
                  name="isShippableProduct"
                  variant="contained"
                  color={campaignInfo.gender === 'All' ? 'primary' : ''}
                  className={`
                    ${classes.urlButton}
                    ${
                      campaignInfo.gender === 'All'
                        ? classes.urlButtonSelected
                        : ''
                    }
                  `}
                  onClick={() => genderClick('All')}
                >
                  All
                </Button>
                <Button
                  id="isShippableProduct"
                  name="isShippableProduct"
                  variant="contained"
                  color={campaignInfo.gender === 'Male' ? 'primary' : ''}
                  className={`
                    ${classes.urlButton}
                    ${classes.buttonMargin}
                    ${
                      campaignInfo.gender === 'Male'
                        ? classes.urlButtonSelected
                        : ''
                    }
                  `}
                  onClick={() => genderClick('Male')}
                >
                  Male
                </Button>
                <Button
                  id="isNotShippableProduct"
                  name="isNotShippableProduct"
                  variant="contained"
                  color={campaignInfo.gender === 'female' ? 'primary' : ''}
                  className={`
                    ${classes.urlButton}
                    ${classes.buttonMargin}
                    ${
                      campaignInfo.gender === 'female'
                        ? classes.urlButtonSelected
                        : ''
                    }
                  `}
                  onClick={() => genderClick('female')}
                >
                  Female
                </Button>
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div className={classes.rowSection}>
                <div>
                  <Typography gutterBottom align="left" display="inline">
                    Target Country
                  </Typography>
                  <HpTooltip
                    styling={{
                      marginLeft: '5px',
                      marginBottom: '2px'
                    }}
                    message={
                      "Select which country you'd like to market your product in. If there is no specific country select 'All'."
                    }
                  />
                </div>
                <TextField
                  id="country"
                  name="country"
                  select
                  className={classes.select}
                  SelectProps={{
                    MenuProps: {
                      className: classes.selectMenu
                    }
                  }}
                  onChange={changeHandler}
                  margin="normal"
                  variant="outlined"
                  value={country}
                >
                  {countries.map((item, i) => (
                    <MenuItem key={item.key} value={item.value}>
                      {item.value}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </Grid>
            <Grid item sm={12} style={{ width: '100%' }}>
              <div className={classes.rowSection}>
                <div>
                  <Typography gutterBottom align="left" display="inline">
                    Age Range
                  </Typography>
                  <HpTooltip
                    styling={{
                      marginLeft: '5px',
                      marginBottom: '2px'
                    }}
                    message={'Select the ages you want to target.'}
                  />
                </div>
                <Slider
                  defaultValue={12}
                  aria-labelledby="range-slider"
                  valueLabelDisplay="auto"
                  step={1}
                  onChange={ageSelectionHandler}
                  value={[campaignInfo.ageMin, campaignInfo.ageMax]}
                  valueLabelDisplay="on"
                  min={0}
                  max={110}
                  className={classes.minAgeSlider}
                />
              </div>
            </Grid>
            <Grid item sm={12}>
              <div className={classes.rowSection}>
                <Typography
                  gutterBottom
                  align="left"
                  className={classes.scaleText}
                >
                  Influencer Level
                </Typography>
                <div className={classes.levelContainer}>
                  <Typography
                    gutterBottom
                    align="left"
                    variant="caption"
                    className={classes.scaleCaption}
                  >
                    Choose lowest level of influence you wish to target. For
                    example if you are interested in influencers with 500-10k
                    subscribers, choose "Micro".
                  </Typography>
                </div>
                <Grid container direction="row" sm={12}>
                  <Grid
                    container
                    direction="row"
                    sm={4}
                    className={classes.socialSelection}
                    onClick={() => influenceLevelClick('micro')}
                  >
                    <StyledButton
                      className={`${
                        campaignInfo.influenceLevel === 'micro'
                          ? classes.iconSelected
                          : classes.icon
                      }`}
                    >
                      <Person />
                    </StyledButton>
                    <div className={classes.LevelDiv}>
                      <Typography
                        gutterBottom
                        variant="h6"
                        className={`${
                          campaignInfo.influenceLevel === 'micro'
                            ? classes.itemSelected
                            : classes.item
                        }`}
                      >
                        Micro
                      </Typography>
                      <Typography gutterBottom variant="caption">
                        100 to 10,000 followers
                      </Typography>
                    </div>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    sm={4}
                    className={classes.socialSelection}
                    onClick={() => influenceLevelClick('macro')}
                  >
                    <StyledButton
                      className={`${
                        campaignInfo.influenceLevel === 'macro'
                          ? classes.iconSelected
                          : classes.icon
                      }`}
                    >
                      <Group />
                    </StyledButton>
                    <div className={classes.LevelDiv}>
                      <Typography
                        gutterBottom
                        variant="h6"
                        className={`${
                          campaignInfo.influenceLevel === 'macro'
                            ? classes.itemSelected
                            : classes.item
                        }`}
                      >
                        Macro
                      </Typography>
                      <Typography gutterBottom variant="caption">
                        10,000 to 100,000 followers
                      </Typography>
                    </div>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    sm={4}
                    className={classes.socialSelection}
                    onClick={() => influenceLevelClick('mega')}
                  >
                    <StyledButton
                      className={`${
                        campaignInfo.influenceLevel === 'mega'
                          ? classes.iconSelected
                          : classes.icon
                      }`}
                    >
                      <Public />
                    </StyledButton>
                    <div className={classes.LevelDiv}>
                      <Typography
                        gutterBottom
                        variant="h6"
                        className={`${
                          campaignInfo.influenceLevel === 'mega'
                            ? classes.itemSelected
                            : classes.item
                        }`}
                      >
                        Mega
                      </Typography>
                      <Typography gutterBottom variant="caption">
                        100,000+ followers
                      </Typography>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className={classes.buttons}>
          <Button onClick={backButtonClick} className={classes.backButton}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={nextButtonClick}
            className={classes.nextButton}
          >
            Next
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

CampaignAudience.PropTypes = {
  campaignInfo: PropTypes.object,
  changeHandler: PropTypes.func,
  influenceLevelClick: PropTypes.func,
  genderClick: PropTypes.func,
  ageSelectionHandler: PropTypes.func
};

export default withStyles(styles)(CampaignAudience);



// WEBPACK FOOTER //
// ./src/components/company/campaign/components/CampaignAudience.js